import { Lightning, Utils } from "@lightningjs/sdk";
export class Spinner extends Lightning.Component {
    static _template() {
        return {
            w: 100,
            h: 100,
            pivot: 0.5,
            texture: Lightning.Tools.getSvgTexture(Utils.asset("images/player/spinner.svg"), 200, 200),
        };
    }
    _init() {
        this._spinnerAnimation = this.animation({
            duration: 1,
            repeat: -1,
            actions: [
                {
                    p: "rotation",
                    v: {
                        0: { v: 0, sm: 0, s: 0 },
                        1: { v: 2 * Math.PI, sm: 0, s: 0 },
                    },
                },
            ],
        });
    }
    _active() {
        var _a, _b;
        if (typeof window !== "undefined" &&
            ((_a = window.matchMedia) === null || _a === void 0 ? void 0 : _a.call(window, "(prefers-reduced-motion: reduce)").matches))
            return;
        (_b = this._spinnerAnimation) === null || _b === void 0 ? void 0 : _b.start();
    }
    _inactive() {
        var _a;
        (_a = this._spinnerAnimation) === null || _a === void 0 ? void 0 : _a.stopNow();
    }
}
export default Spinner;
//# sourceMappingURL=Spinner.js.map